// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","9977":"libs"}[chunkId] + "." + {"532":"e235c7820ad122a8d0e6","9977":"8a1f13f8e4591bdf54fe"}[chunkId] + ".css";
};